import { VariantColor } from '@repo/toolkit/colors'
import { DateFormatter } from '@repo/toolkit/date'

import { RoleEnum } from '../../enums/users/role.enum'
import { HostFamily } from './host-family'

export class HostFamilyProperties {
  static get dateOfVisitThreshold(): number {
    return 24
  }

  static dateOfVisitColor(hostFamily: HostFamily): VariantColor | undefined {
    if (!hostFamily.dateOfVisit) return 'darkBlue'
    return DateFormatter.yearDiff(hostFamily.dateOfVisit, new Date()) > 2 ? 'danger' : 'darkBlue'
  }

  // "Famille [Name], [address] [code postal] [ville]", e.g. "Famille Whitaker, 28 vision street, RH7 Lingfield"
  static getFamilyNameWithAddress(
    hostFamily: Pick<HostFamily, 'familyName'> &
      Partial<Pick<HostFamily, 'address1' | 'address2' | 'zipCode' | 'city'>>
  ): string {
    const address = [hostFamily.address1, hostFamily.address2].filter(Boolean).join(' ')
    const location = [hostFamily.zipCode, hostFamily.city].filter(Boolean).join(' ')
    return [`Famille ${hostFamily.familyName}`, address, location].filter(Boolean).join(', ')
  }

  static hasVisibleLecComment(
    hostFamily:
      | { lecComments?: Pick<HostFamily['lecComments'][number], 'sharedToOl'>[] }
      | undefined,
    userRole?: RoleEnum
  ): boolean {
    if (!hostFamily?.lecComments) return false
    if (userRole === RoleEnum.ADMIN) return hostFamily.lecComments.length > 0
    return hostFamily.lecComments.some((comment) => comment.sharedToOl)
  }
}
